"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = require("styled-components");

var _styles = require("./styles");

var _excluded = ["bgColor", "border", "borderColor", "children", "paddingType", "paddingSize", "radius", "theme"];

var Box = function Box(_ref) {
  var bgColor = _ref.bgColor,
      border = _ref.border,
      borderColor = _ref.borderColor,
      children = _ref.children,
      paddingType = _ref.paddingType,
      paddingSize = _ref.paddingSize,
      radius = _ref.radius,
      theme = _ref.theme,
      rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_styles.Container, Object.assign({
    border: border,
    borderColor: theme.colors[borderColor] || theme.colors.neutral400,
    paddingType: paddingType,
    paddingSize: paddingSize,
    background: theme.colors[bgColor].color + theme.colors[bgColor].scale || theme.colors.ghost,
    radius: radius
  }, rest), children);
};

Box.defaultProps = {
  bgColor: 'ghost',
  borderColor: 'ghost',
  paddingType: 'square',
  paddingSize: 'sm',
  radius: 'none'
};

var _default = (0, _styledComponents.withTheme)(Box);

exports.default = _default;